// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WaitSvg from '@rsuite/icon-font/lib/flow/Wait';
var Wait = createSvgIcon({
  as: WaitSvg,
  ariaLabel: 'wait',
  category: 'flow',
  displayName: 'Wait'
});
export default Wait;